import { lazy, Suspense } from "react";
import { ClientOnly } from "remix-utils/client-only";

import { TimetableDesktop } from "./TimetableDesktop";
import { TimetableMobile } from "./TimetableMobile";

import { StepLoader } from "~/components/Loader";
import { Media } from "~/components/Media";
import { useStateManager } from "~/modules/StateManager.hooks";
import { TimetableLoaderData } from "~/modules/timetable/timetable.loader.server";

// Lazy loading month view for now, as this is an experimental feature.
// NOTE: Lazy loaded components needs to be wrapped with <ClientOnly> + <Suspense> untill we switch to latest react 18 server API

const TimetableMonth = lazy(() =>
  import("~/modules/timetable/components/TimetableMonth").then((mod) => ({
    default: mod.TimetableMonth,
  })),
);

export function Timetable(props: TimetableLoaderData) {
  const { state } = useStateManager();

  const IS_MONTH_VIEW = state.config.application.timetableUI === "month";

  const element = (
    <>
      <Media data-component="TimetableDesktop" showFor="desktop">
        {IS_MONTH_VIEW ? <TimetableMonth {...props} /> : <TimetableDesktop {...props} />}
      </Media>
      <Media data-component="TimetableMobile" showFor="mobile">
        {IS_MONTH_VIEW ? <TimetableMonth {...props} /> : <TimetableMobile {...props} />}
      </Media>
    </>
  );

  if (props.serverTimeZone === null || IS_MONTH_VIEW) {
    return (
      <ClientOnly fallback={<StepLoader />}>
        {() => <Suspense fallback={<StepLoader />}>{element}</Suspense>}
      </ClientOnly>
    );
  }

  return element;
}
